<button
class="button button--brand button--full_width"
    [ngClass]="{ 'border-2 border-red-500': active === true }"
(click)="toggleSelectProperty()"
>
Select parcels to make up the property boundary
</button>
